import React from 'react';
import { Euro, Clock, Shield } from 'lucide-react';

const VORTEILE = [
  {
    icon: Euro,
    title: 'Faire Provisionen',
    text: '30–50% Provision auf reguliertes Grundhonorar. Staffelmodell basierend auf Fallzahl.'
  },
  {
    icon: Clock,
    title: 'Einfacher Ablauf',
    text: 'Digitale Fall-Erfassung, klare Prozesse, schnelle Abwicklung über unser Partner-Portal.'
  },
  {
    icon: Shield,
    title: 'Professionelle Abwicklung',
    text: 'Qualifizierte Begutachtung, strukturierte Dokumentation, zuverlässige Auszahlung.'
  }
];

export const WarumPartner = () => {
  return (
    <section className="py-28 lg:py-36 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/8 text-brand-green-dark rounded-full text-sm font-semibold mb-6 border border-brand-green/15">
            Ihre Vorteile
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            Warum Partner werden?
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {VORTEILE.map((vorteil, index) => {
            const Icon = vorteil.icon;
            return (
              <div key={index} className="bg-white border border-gray-200 rounded-3xl p-8 hover:border-brand-green/30 hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-brand-green/10 rounded-2xl flex items-center justify-center mb-6 border border-brand-green/15">
                  <Icon className="w-8 h-8 text-brand-green" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 tracking-tight">{vorteil.title}</h3>
                <p className="text-gray-600 leading-relaxed text-[15px]">{vorteil.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};